export default {
  COMMENT: 'COMMENT',
  EMAIL: 'EMAIL',
  SMS: 'SMS',
};
